@if (showTable) {
  <snelstart-ui-table [config]="tableConfig">
    <snelstart-ui-table-col
      [showFilter]="false"
      [showSort]="false"
      columnType="string"
      name="label"
      width="400px"
    >
      <snelstart-ui-table-col-header>
        <div style="font-size: 13px; color: #00200b ">
          <div *ngIf="client.name && !this.hasPartner">
            {{ this.client.name }}
          </div>
          <div *ngIf="client.name && this.hasPartner">
            {{ this.client.name }} en partner
          </div>
        </div>
      </snelstart-ui-table-col-header>

      <snelstart-ui-table-expanded-row>
        <div *ngFor="let option of options; let i = index;">
          <div *ngFor="let subOnderdeel of option.subonderdelen!; let j = index;">
            <div *ngIf="subOnderdeel.visible">
              <snelstart-ui-button (click)="navigateToSubPage(subOnderdeel.pageMapping)" class="ps-5" icon="chevron-right"
                                   type="link">

                <div
                  [ngStyle]="subOnderdeel.pageMapping === activePage ? {'color': '#0073dd', 'font-weight': 'bold'} : {}">
                  {{ subOnderdeel.label }}
                </div>
              </snelstart-ui-button>
            </div>
          </div>
        </div>
      </snelstart-ui-table-expanded-row>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [decimals]="2"
                            [showFilter]="false"
                            [showSort]="false"
                            columnType="currency"
                            i18n-displayName
                            name="onderdelenAanvullendeTekst"
                            width="250px">
      <snelstart-ui-table-col-header></snelstart-ui-table-col-header>

      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          <ng-container>
            <a *ngIf="record.value === 0">Bedrag zorgtoeslag:</a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 1">Bedrag kindgebonden budget:</a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 2">Bedrag kinderopvangtoeslag:</a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 3">Bedrag huurtoeslag:</a>
          </ng-container>
          <ng-container *ngIf="this.sumSaldo >= 0">
            <a *ngIf="record.value === 4">Nog te betalen:</a>
          </ng-container>
          <ng-container *ngIf="this.sumSaldo < 0">
            <a *ngIf="record.value === 4">Nog te ontvangen:</a>
          </ng-container>
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [decimals]="2"
                            [showFilter]="false"
                            [showSort]="false"
                            columnType="currency"
                            i18n-displayName
                            name="berekening"
                            width="250px"
    >
      <snelstart-ui-table-col-header>
        <div style="font-size: 13px; color: #00200b ">
          {{ this.allowanceEntity.year }}
        </div>
      </snelstart-ui-table-col-header>

      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          <ng-container>
            <a *ngIf="record.value === 0">{{ (this.rechtOpZorg || 0).toLocaleString()  }}</a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 1">{{( this.rechtOpKgb|| 0).toLocaleString() }}</a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 2">{{ (this.rechtOpKot|| 0).toLocaleString()  }}</a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 3">{{ (this.rechtOpHuur|| 0).toLocaleString() }}</a>
          </ng-container>
          <ng-container *ngIf="this.sumSaldo >= 0">
            <a *ngIf="record.value === 4">{{ (this.sumSaldo).toLocaleString() }}</a>
          </ng-container>
          <ng-container *ngIf="this.sumSaldo < 0">
            <a *ngIf="record.value === 4">{{ (this.sumSaldo * -1).toLocaleString() }}</a>
          </ng-container>
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
  </snelstart-ui-table>

  <snelstart-venture-fiscaal-domain-logic-service [(dialogVisible)]="this.dialogVisible"
                                                  [title]="'Nieuwe toeslagen aan'"
  >
  </snelstart-venture-fiscaal-domain-logic-service>
}
